import { Add, Close, Delete, EditOutlined } from '@mui/icons-material';
import { Alert, Button, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Modal, Select, Snackbar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { TagsFilled } from '@ant-design/icons';
import { Button as AntButton, Col, Input, Pagination, Row } from "antd";
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import { DeleteModal } from 'components/Dialog';
import Loading from 'components/Loading';
import { filter, get, has, map } from "lodash";
import { useOneGameCategory } from 'store/1GameCategory/selectors';
import { handleCreateOneGameCategory, handleListOneGameCategory } from 'store/1GameCategory/thunks';
import { useOneGameGallery } from 'store/1GameGallery/selectors';
import { handleCreateOneGameGallery, handleDeleteCategoryGallery, handleDeleteOneGameGallery, handleListOneGameGallery } from 'store/1GameGallery/thunks';
import { handleUpdateOneGameVideo } from 'store/1GameVideo/thunks';
import styled from 'styled-components';
import { AllDataIdOneGameAdmin } from 'utils/config/reference';
import COLOR from 'utils/constants/color';
import { v4 } from 'uuid';

// import { GAME_GALLERY } from 'utils/config/reference';






import {
    CheckCircle,
    DeleteOutlineRounded
} from '@mui/icons-material';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import EnterIcon from "../../utils/assets/images/enter-icon.webp";



const PAGE_CATEGORY = [
    "ANÉCDOTAS SERIES",
    "AP SPANISH LANGUAGE",
    "PROFICIENCY LEVELS",
    "LITERACY"
]

const ModalContent = styled.div`
    left: 50%;
    width:70vw;
    max-width: 500px;
    padding: 0px 24px;
    position: absolute;
    min-height:350px;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color:#fff;
    padding:20px;
     @media only screen and (max-width: 600px) {
        width: 90%;
    }
`;
const ModalConfigArea = styled.div`
    // min-height:44vh;
    // max-height:90vh;
    height: 430px;
    overflow:auto;
    margin-top:10px;
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
`;

const OverViewDist = styled.p`
  font-size:20px;
  font-weight:600;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 80px;
  border-radius: 12px;
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: nowrap;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const MenuBtn = styled.button`
  background-color: white;
  border-top: none;
  border-left: none;
  border-right: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;
const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: '4px',
    },
}));

const EditVideo = ({ editResourseModal, onCloseModal, item, galleryCategory }) => {
    const galleryItems = galleryCategory?.filter(item => item.value !== "All")
    const [poster, setPoster] = useState('')
    const [title, setTitle] = useState('')
    const [category, setCategory] = useState('')
    const [loading, setloading] = useState(false)
    const [error, setError] = useState([])
    const classes = useStyles();
    const dispatch = useDispatch()
    
    useEffect(() => {
        if (item) {
            setPoster(get(item, "image_url", ''))
            setTitle(get(item, "title", ''))
            setCategory(get(item, "category", ''))
            setError([])
        } else {
            // Reset form when no item is provided
            setPoster('')
            setTitle('')
            setCategory('')
            setError([])
        }
    }, [item])
    
    const onCreateOrUpdate = async () => {
        let err = []
        if (!poster) {
            err.push({
                key: "poster", message: 'Poster image required!'
            })
        }
        if (!category) {
            err.push({
                key: "category", message: 'Category  required!'
            })
        }
        setError(err)
        if (err.length == 0) {
            setloading(true)
            try {
                if (has(item, "id")) {
                    const data = {
                        ...item,
                        image_url: poster,
                        title,
                        category,
                    }
                    await dispatch(handleUpdateOneGameVideo(data))
                } else {
                    const data = {
                        image_url: poster,
                        category,
                    }
                    await dispatch(handleCreateOneGameGallery(data))
                }
                onCloseModal()
            } catch (error) {
                console.error('Error creating/updating gallery item:', error)
            } finally {
                setloading(false)
            }
        }
    }
    
    return (<Modal
        open={editResourseModal}
        onClose={() => { }}
        style={{ height: '100%', width: '100%' }}
    >
        <ModalContent>
            <Row style={{ justifyContent: "space-between" }}>
                <TitleText>{has(item, "id") ? 'Update Gallery' : 'Add Gallery'}</TitleText>
                <IconButton onClick={onCloseModal} style={{ padding: 0 }}>
                    <Close color="secondary" />
                </IconButton>
            </Row>
            <ModalConfigArea>
                <Row>
                    <Col lg={12} xs={24} style={{ paddingLeft: 10, paddingTop: 10, width: "100%", flex: 1, maxWidth: "unset", marginRight:"6px" }}>
                        <PageImagePicker
                            src={poster}
                            path={`/poster}`}
                            style={{ marginBottom: 24 }}
                            onChange={item => {
                                setPoster(item.url)
                                setError(filter(error, e => e.key != "poster"))
                            }}
                            hasDescription={false}
                        />
                        <Row justify="start" style={{ marginBottom: 10, }}>
                            <Col xs={24} lg={24}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <InputLabel style={{ backgroundColor: 'white' }} id="Categorias">Categories</InputLabel>
                                    <Select
                                        labelId="Categorias"
                                        id="Categorias"
                                        value={category}
                                        onChange={(v) => {
                                            setCategory(v.target.value)
                                            setError(filter(error, e => e.key != "category"))
                                        }}
                                        label="Categorias"
                                    >
                                        {galleryItems?.map(v => (<MenuItem key={v.id} value={v.id}>{v.value}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </Col>
                        </Row>
                        {error.length > 0 ? <Row style={{ marginTop: 10, marginRight: 0, marginLeft: 0, flexDirection: "column", display: "flex" }}>
                            {error.map(v => (<FormHelperText key={v.key} error>
                                * {get(v, "message")}
                            </FormHelperText>))}
                        </Row> : null}
                        <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                            <Button disabled={loading} fullWidth onClick={onCreateOrUpdate} variant="contained" color="primary">
                                {loading ? <Loading white size={15} /> : null}
                                {has(item, "id") ? "Update" : "Create"} </Button>
                        </Row>
                    </Col>
                </Row>
            </ModalConfigArea>
        </ModalContent>
    </Modal>)
}

export default function LearnScreen() {
    const showAlert = useAlert();
    const categoryData = useOneGameCategory();
    const galleryCategory = categoryData[0]?.meta_data;
    const gallery = useOneGameGallery();
    const [loading, setLoading] = useState(false)
    const [deleteToggle, setDeleteToggle] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [dataTab, setDataTab] = useState(galleryCategory ? galleryCategory[0]?.id : "");
    const dispatch = useDispatch()
    const [videoModalInfo, setVideoModalInfo] = React.useState({
        open: false,
        item: null
    });
    const [filtertedData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemPerPage] = useState(9);

    // Fixed pagination calculation to ensure consistent pagination
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = filtertedData.slice(startIndex, endIndex);

    const [addCategory, setAddCategory] = useState({
        active: false,
        value: "",
        editActive: false,
        editValue: { id: "", value: "" },
        editValues: {}, // Add this to store all edit values
        selectedItem: "",
        loading: false
    });
    const [alertSakeBar, setAlertSakeBar] = useState({ open: false, message: '', severity: "success" })

    const filterTutorialGallery = filter(gallery, (item) => item.category === dataTab);
    const getCategory = galleryCategory?.find((val) => val.id === dataTab)

    const closeAlert = () => {
        setAlertSakeBar({ open: false, message: '', severity: 'success' })
    }

    const fetchItem = async () => {
        await dispatch(handleListOneGameGallery())
    }

    const fetchCategoryList = async () => {
        await dispatch(handleListOneGameCategory("pictures_categories"))
    }

    useEffect(() => {
        if (getCategory?.value === "All") {
            setFilteredData(gallery);
            return;
        }
        setFilteredData(filterTutorialGallery);
        // Reset to page 1 when changing tabs
        setCurrentPage(1);
    }, [dataTab, gallery])

    useEffect(() => {
        fetchCategoryList()
        fetchItem()
        if (galleryCategory && galleryCategory.length > 0) {
            setDataTab(galleryCategory[0]?.id || AllDataIdOneGameAdmin);
        }
    }, [])
    
    // Update dataTab when galleryCategory loads
    useEffect(() => {
        if (galleryCategory && galleryCategory.length > 0 && !dataTab) {
            setDataTab(galleryCategory[0]?.id || AllDataIdOneGameAdmin);
        }
    }, [galleryCategory])
    
    const onAdd = () => {
        setVideoModalInfo({ open: true, item: {} })
    }
    
    const handleEdit = (item) => {
        setVideoModalInfo({ open: true, item: item })
    }
    
    const onDeleteItem = async () => {
        if (has(selectedItem, "id")) {
            setLoading(true)
            try {
                await dispatch(handleDeleteOneGameGallery(selectedItem.id))
            } catch (error) {
                console.error('Error deleting gallery item:', error)
            } finally {
                setLoading(false)
            }
        }
        setSelectedItem(null)
        setDeleteToggle(false)
    }
    
    function navigationToMenu(id) {
        setDataTab(id);
        setAddCategory((prev) => ({
            ...prev,
            active: false,
            editActive: false, // Close edit mode when navigating
        }));
        setCurrentPage(1);
    }

    const handleEditCategory = (action, event, id) => {
        switch (action) {
            case "edit":
                return setAddCategory((prev) => ({
                    ...prev,
                    editValue: { value: event?.target?.value || "", id },
                }));
            case "open":
                // Initialize edit values with current category values when opening edit mode
                const initialEditValues = {};
                if (!addCategory.editActive) {
                    galleryCategory.forEach(category => {
                        if (category.value !== "All") {
                            initialEditValues[category.id] = category.value;
                        }
                    });
                }
                return setAddCategory((prev) => ({
                    ...prev,
                    editActive: !prev.editActive,
                    active: false,
                    editValues: initialEditValues, // Use plural to store all category values
                    editValue: { id: "", value: "" }, // Keep this for compatibility
                }));

            default:
                return null;
        }
    };

    const updateState = async (name, value) => {
        setAddCategory((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const deleteCategory = (id) => {
        const fetchGallery = filter(gallery, (item) => item.category === id);
        if (fetchGallery?.length > 0) {
            return showAlert("Please delete all the Images from this category before deleting.", "error");
        }
        updateState("selectedItem", id);
        setDeleteToggle(true);
    };

    const handleDeleteCategory = async () => {
        try {
            setLoading(true);
            const { meta_data, ...data } = categoryData[0];
            const payload = {
                ...data,
                meta_data: galleryCategory.filter(
                    (data) => data.id !== addCategory?.selectedItem
                ),
            };
            await dispatch(handleCreateOneGameCategory(payload));
            updateState("selectedItem", "");
            await dispatch(handleDeleteCategoryGallery(addCategory?.selectedItem))
            setDeleteToggle(false);
            handleEditCategory("open");
            
            // If the deleted category was the active one, switch to the first available category
            if (dataTab === addCategory?.selectedItem) {
                const remainingCategories = galleryCategory.filter(
                    (data) => data.id !== addCategory?.selectedItem
                );
                if (remainingCategories.length > 0) {
                    setDataTab(remainingCategories[0].id);
                }
            }
        } catch (error) {
            console.error('Error deleting category:', error);
            setAlertSakeBar({
                open: true,
                message: "Error deleting category. Please try again.",
                severity: "error",
            })
        }
        finally {
            setLoading(false);
        }
    };

 const handleEditSaveCategory = async () => {
    try {
        // Find categories that have been modified
        const modifiedCategories = Object.keys(addCategory.editValues || {}).filter(key => {
            const originalValue = galleryCategory.find(cat => cat.id === key)?.value || "";
            const newValue = addCategory.editValues[key] || "";
            return newValue.trim() !== originalValue.trim() && newValue.trim() !== "";
        });

        if (modifiedCategories.length === 0) {
            setAlertSakeBar({
                open: true,
                message: "No changes detected.",
                severity: "warning",
            });
            return;
        }

        // Process the first modified category (you can extend this to handle multiple)
        const categoryToEdit = modifiedCategories[0];
        const newValue = addCategory.editValues[categoryToEdit]?.trim();

        if (!newValue) {
            setAlertSakeBar({
                open: true,
                message: "Category should not be empty.",
                severity: "error",
            });
            return;
        }

        // Check for duplicate category names
        const isDuplicate = galleryCategory.some(
            (element) => 
                element.id !== categoryToEdit && 
                element.value.toLowerCase().trim() === newValue.toLowerCase()
        );

        if (isDuplicate) {
            setAlertSakeBar({
                open: true,
                message: "Category name already exists.",
                severity: "error",
            });
            return;
        }

        const updatedGalleryCategory = galleryCategory.map((element) => {
            if (element.id === categoryToEdit) {
                return { ...element, value: newValue };
            }
            return element;
        });

        const payload = {
            ...categoryData[0],
            meta_data: updatedGalleryCategory,
        };

        await dispatch(handleCreateOneGameCategory(payload));

        setAddCategory((prev) => ({
            ...prev,
            editActive: false,
            editValue: { id: "", value: "" },
            editValues: {},
        }));

        setAlertSakeBar({
            open: true,
            message: "Category updated successfully.",
            severity: "success",
        });
    } catch (error) {
        console.error('Error updating category:', error);
        setAlertSakeBar({
            open: true,
            message: "Error updating category. Please try again.",
            severity: "error",
        });
    }
};

    const addGalleryCategory = async () => {
        try {
            setAddCategory((prev) => ({
                ...prev,
                loading: true,
            }));
            
            const trimmedValue = addCategory?.value?.trim();
            if (!trimmedValue) {
                setAlertSakeBar({
                    open: true,
                    message: "Category should not be empty.",
                    severity: "error",
                })
                return;
            }
            
            // Check for duplicate category names
            const isDuplicate = galleryCategory?.some(
                (element) => element.value.toLowerCase() === trimmedValue.toLowerCase()
            );
            
            if (isDuplicate) {
                setAlertSakeBar({
                    open: true,
                    message: "Category name already exists.",
                    severity: "error",
                })
                return;
            }
            
            const createCategory = {
                id: v4(),
                value: trimmedValue,
            };

            const { meta_data = [], ...data } = categoryData[0] || {};
            const updatedMetaData = [...meta_data];
            updatedMetaData.splice(1, 0, createCategory);
            
            const payload = {
                ...data,
                meta_data: updatedMetaData,
            };
            
            await dispatch(handleCreateOneGameCategory(payload));

            setAddCategory((prev) => ({
                ...prev,
                active: false,
                value: "",
            }));
            
            setAlertSakeBar({
                open: true,
                message: "Category added successfully.",
                severity: "success",
            })
        } catch (error) {
            console.error('Error adding category:', error);
            setAlertSakeBar({
                open: true,
                message: "Error adding category. Please try again.",
                severity: "error",
            })
        } finally {
            setAddCategory((prev) => ({
                ...prev,
                loading: false,
            }));
        }
    };

const handleKeyPress = async (event, actionType) => {
    if (event.key === "Enter") {
        event.preventDefault();
        switch (actionType) {
            case "add-category-item":
                return addGalleryCategory();
            case "edit-category-item":
                return handleEditSaveCategory();
            default:
                return null;
        }
    }
};
    
    const handleAddCategoryInputChange = (e) => {
        try {
            const value = e?.target?.value || "";
            setAddCategory((prev) => ({
                ...prev,
                value: value,
            }));
        } catch (error) {
            console.error('Error handling input change:', error);
        }
    };

    const handleAddCategory = (event, action) => {
        setAddCategory((prev) => ({
            ...prev,
            active: !prev.active,
            value: "",
            editActive: false,
        }));
    };

    const onCancelGalleryImage = () => {
        setDeleteToggle(false);
    };

    const onCancel = () => {
        updateState("selectedItem", "");
        setDeleteToggle(false);
    };
    
    // Handle page change with explicit logic
    const handleShowSizeChange = (page) => {
        setItemPerPage(page);
    };

    const handleEditInputChange = (categoryId, event) => {
    try {
        const value = event?.target?.value || "";
        setAddCategory(prev => ({
            ...prev,
            editValues: {
                ...prev.editValues,
                [categoryId]: value
            }
        }));
    } catch (error) {
        console.error('Error handling edit input change:', error);
    }
};

    // Don't render until galleryCategory is loaded
    if (!galleryCategory) {
        return <Loading />;
    }
    
    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={alertSakeBar.open}
                autoHideDuration={3000}
                onClose={closeAlert}>
                <Alert onClose={() => { setAlertSakeBar({ open: false, message: '' }) }} severity={alertSakeBar.severity}>
                    <strong>ALERT:</strong> {alertSakeBar.message}
                </Alert>
            </Snackbar>
            <EditVideo
                galleryCategory={galleryCategory}
                editResourseModal={videoModalInfo.open}
                item={videoModalInfo.item}
                onCloseModal={() => setVideoModalInfo({ open: false, item: null })}
            />
            <DeleteModal
                deleteToggle={deleteToggle}
                setDeleteToggle={setDeleteToggle}
                onDelete={addCategory?.selectedItem !== "" ? handleDeleteCategory : onDeleteItem}
                message={addCategory?.selectedItem !== "" ? `Are you sure you want to delete this gallery category?` : `Are you sure you want to delete this gallery image?`}
                loading={loading}
                type={"delete-category"}
                onCancel={addCategory?.selectedItem !== "" ? onCancel : onCancelGalleryImage}
            />

            <Row>
                <Col>
                    <OverViewDist>
                        1Game Gallery
                    </OverViewDist>
                </Col>
            </Row>
            <Row justify={"end"} align={"center"} style={{ gap: 5 }}>
                <AntButton color="primary" onClick={handleAddCategory} className='add-button'>
                    <Row align={"center"}>
                        <Add />
                    </Row>
                </AntButton>
                <AntButton className="edit-button" onClick={() => handleEditCategory("open")} >
                    <Row align={"center"}>
                        <EditOutlined />
                    </Row>
                </AntButton>
            </Row>
            {addCategory.active && (
                <Row align={"center"} justify={"end"} style={{gap: 5, position: "relative"}} className='mt-10px'>
                  <div className='enter-icon'>
                    {addCategory?.loading ? <Loading size={17} /> :  <img className='cursor-pointer' width={"27px"} onClick={addGalleryCategory}  src={EnterIcon} alt='enter-icon' /> }
                  </div>
                  <Input 
                    maxLength={30} 
                    placeholder='Add a category' 
                    type='text'  
                    onKeyDown={(event) => handleKeyPress(event, "add-category-item")}  
                    value={addCategory?.value} 
                    onChange={handleAddCategoryInputChange} 
                    className='w-300px' 
                  />
                </Row>
            )}
            <MenuWrapper top={"10px"} style={{ width: "100%" }}>
                {galleryCategory?.map((x, index) => (
                    <React.Fragment key={x.id}>
                        {addCategory?.editActive && x.value !== "All" ? (
                            <div style={{ position: "relative" }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'end'
                                }}>
                                   <CheckCircle 
                                     onClick={handleEditSaveCategory} 
                                     className='check-icon-on-gallery' 
                                     style={{ cursor: 'pointer', color: 'green' }}
                                   />
                                   <DeleteOutlineRounded 
                                     onClick={() => deleteCategory(x.id)} 
                                     style={{ cursor: 'pointer', color: 'red' }} 
                                     className="cancel-icon-on-gallery" 
                                   />
                                </div>
                                <MenuBtn 
                                  style={{ 
                                    borderBottom: dataTab === x?.id ? '5px solid rgb(28,49,115)' : '5px solid #fcfcfc', 
                                    color: dataTab === x?.id ? 'rgb(28,49,115)' : 'black' 
                                  }} 
                                //   onClick={() => navigationToMenu(x.id)}
                                >
                                   <Input 
                                    maxLength={30} 
                                    onKeyDown={(event) => handleKeyPress(event, "edit-category-item")} 
                                    value={addCategory?.editValues?.[x.id] !== undefined ? addCategory.editValues[x.id] : x.value} 
                                    onChange={(event) => handleEditInputChange(x.id, event)}
                                    style={{ 
                                        background: 'transparent', 
                                        border: 'none', 
                                        outline: 'none',
                                        width: '100%',
                                        textAlign: 'center',
                                        fontSize: '16px',
                                        fontWeight: '600'
                                    }}
                                    />
                                </MenuBtn>
                            </div>
                        ) : (
                            <div style={{ position: "relative" }}>
                                <MenuBtn 
                                  style={{ 
                                    borderBottom: dataTab === x?.id ? '5px solid rgb(28,49,115)' : '5px solid #fcfcfc', 
                                    color: dataTab === x?.id ? 'rgb(28,49,115)' : 'black' 
                                  }} 
                                  onClick={() => navigationToMenu(x.id)}
                                >
                                    {x.value}
                                </MenuBtn>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </MenuWrapper>

            <Button variant="contained" color="primary" style={{ marginTop: 24 }} onClick={onAdd}>
                <Add /> Add Gallery
            </Button>
            <Row className="learnContentUpr" gutter={[25, 0]}>
                <Col xs={24} sm={24} md={24}>
                    <div className="learnContent">
                        <div className='myCategorys'>
                            {map(paginatedData, category => {
                                const getCategory = galleryCategory?.find((val) => val.id === category?.category)
                                return (
                                    <div key={category.id} className='myCategoryList OneWayVideoCover'>
                                        <div className=" card-resource ShowDetailBnr">
                                            <div className="btnsGrpMain">
                                                <div className="btnsGrpTxt" style={{ justifyContent: "center" }}>
                                                    <Button style={{ marginLeft: 10 }} variant="contained" color="secondary" onClick={() => {
                                                        setSelectedItem(category)
                                                        setDeleteToggle(true)
                                                    }} ><Delete style={{ fontSize: 20, marginRight: 3 }} />Delete</Button>
                                                </div>
                                            </div>
                                            <img src={category.image_url} alt="" />
                                        </div>
                                        <div className='galleryAdminBtnTxt'>
                                            <div className='onway-gallery-admin-txt'>{getCategory?.value}</div>
                                        </div>
                                    </div>
                                )
                            })}
                            {paginatedData?.length === 0 && (
                                <div className='no-data-found'>
                                    <TagsFilled style={{ color: COLOR.primary }} />
                                    <span>No item found</span>
                                </div>
                            )}
                        </div>
                        {filtertedData.length > itemsPerPage && (
                        <Pagination
                            current={currentPage}
                            pageSize={itemsPerPage}
                            total={filtertedData.length}
                            onChange={(page) => setCurrentPage(page)}
                            onShowSizeChange={(current, size) => {
                                setItemPerPage(size);
                                setCurrentPage(1);
                            }}
                            showSizeChanger={true}
                            pageSizeOptions={['9', '18', '27', '36']}
                            style={{ textAlign: 'center', marginTop: '20px' }}
                        />
                    )}
                    </div>
                </Col>
            </Row>
        </>
    );
}